import './Login.css'
import React, {useState} from 'react'
import { Link, useHistory } from 'react-router-dom'
import { auth } from './firebase';
import inmar from './Imagenes/inmar.png'
import 'font-awesome/css/font-awesome.min.css'; 

function Login() {
    const history = useHistory();
    const [email,setEmail]= useState('');
    const[password,setPassword] = useState('');
    const signIn = e => {
       e.preventDefault();

       auth
            .signInWithEmailAndPassword(email, password)
            .then(auth => {
                history.push('/')
            })
            .catch(error => alert(error.message))
    }

    const register= e => {
        e.preventDefault();
        
        auth
        .createUserWithEmailAndPassword(email,password)
        .then(auth => {
            console.log(auth);
            if (auth) {
                history.push('/')
            }
        })
        .catch(error => alert(error.message))
    }
    return (
        <div className= "login">
            <Link to= '/'>
            <img className="login_logo" 
            src={inmar}
            />
            </Link >
            <div className="login_container">
            <Link to= '/'><i className="fa fa-times fa-2x"/></Link>
                <h1>Iniciar Sesión</h1>
                <form>
                    <h5>E-mail</h5>
                    <input type='text' value={email} onChange={e => setEmail(e.target.value)}/>

                    <h5>Contraseña</h5>
                    <input type='password' value={password}
                    onChange={e=> setPassword(e.target.value)}
                    />

                    <button type='submit' onClick={signIn} className ="login_signInButton">Iniciar Sesión</button>
                </form>

                <p>
                    
                    Al iniciar sesión aceptas las Condiciones
                    de Uso y Venta de INMAR. Por favor ve nuestro
                    Aviso de privacidad y cookies.

                    
                </p>
                <button onClick= {register} className="login_registerButton">Escribe mail y contraseña y crea tu cuenta</button>
            </div>
        </div>
    )
}

export default Login
